import { useEffect, useState } from "react";
import axios from "axios";

export default function useOrderingToggle() {
  const [enabled, setEnabled] = useState(true);
  useEffect(() => {
    let alive = true;
    axios
      .get("https://rmrthemeaonlineorderingwebapi.azurewebsites.net/api/TCVariable/value/Mea-Online-Ordering-Website-On-Off?name=Mea-Online-Ordering-Website-On-Off")
      .then((res) => {
        if (!alive) return;
        const rawValue = res.data?.toString().trim().toLowerCase();
        const isOff = rawValue === "off" || rawValue === "0" || rawValue === "false";
        setEnabled(!isOff);
      })
      .catch(() => setEnabled(true));
    return () => { alive = false; };
  }, []);
  return enabled;
}
